import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dic",
  "use": "icon-dic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-dic\"><path d=\"M768 0H288c-9.6 0-22.4 0-32 3.2-73.6 16-128 80-128 156.8v736c0 70.4 57.6 128 128 128h640v-64c-35.2 0-64-28.8-64-64s28.8-64 64-64V0H768zM192 160c0-41.6 25.6-76.8 64-89.6V768c-22.4 0-44.8 6.4-64 16V160z m576 800H256c-35.2 0-64-28.8-64-64s28.8-64 64-64h528c-9.6 19.2-16 41.6-16 64s6.4 44.8 16 64h-16z m0-192H320V64h512v704h-64z\" p-id=\"3480\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dic.svg
// module id = mPW8
// module chunks = 30